import React from 'react';
import PropTypes from 'prop-types';
import { getIconClassForSocialBrand, getLabelForSocialBrand } from 'client/constants/social-media';

export function SocialLink(props) {
  const { socialLink, ariaLabelExtra } = props;
  const title = socialLink.title.toLowerCase();
  const iconClass = getIconClassForSocialBrand(title);
  const label = getLabelForSocialBrand(title);
  const url = socialLink.url.endsWith('/') ? socialLink.url : `${socialLink.url}/`;

  return (
    <a
      href={`${url}?utm_source=edmunds&utm_medium=referral`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${label} ${ariaLabelExtra}`}
      data-tracking-id={props['data-tracking-id']}
      data-tracking-value={title}
    >
      <span className={`icon-${iconClass}`} />
    </a>
  );
}

SocialLink.propTypes = {
  socialLink: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  'data-tracking-id': PropTypes.string,
  ariaLabelExtra: PropTypes.string,
};

SocialLink.defaultProps = {
  'data-tracking-id': '',
  ariaLabelExtra: '',
};
